import styled from 'styled-components';

const RegisterButton = styled.a<{ backgroundColor?: string }>`
  width: 300px;
  height: 80px;
  background: ${({ backgroundColor }) => backgroundColor ?? 'linear-gradient(260.15deg, #CE3FBC 0%, #FC414B 100%)'};
  border: none;
  border-radius: 4px;
  font-weight: bold;
  font-size: 24px;
  color: #FFF;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;

  @media screen and (max-width: 450px) {
    width: 90vw;
  }

  @media screen and (min-width: 450px) {
    width: 320px;
  }

  @media screen and (min-width: 600px) {
    width: 340px;
  }

  @media screen and (min-width: 960px) {
    width: 360px;
  }

  &:not(:first-of-type) {
    margin-top: 20px;
  }
`;

export default RegisterButton;
